import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDRealizadasTotalSemana = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras/realizadasTotalSemana`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_OBRAS_AHD_REALIZADAS_TOTAL_SEMANA", payload: data.yData[0].total });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDRealizadasTotalSemana;